module.exports = __webpack_public_path__ + "img/big.ba9ee378.jpg";